// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { SubscribeNewsGroup } from '../Groups/GroupsImport';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class NewsSubscribeMessage extends PFixMessage {
    constructor() {
        super(Message.CODE_NEWS_SUBSCRIBE_MESSAGE);
    }
    addRouteId(routeID) {
        const group = new SubscribeNewsGroup();
        group.setRouteId(routeID);
        this.addGroup(group);
    }
    setSubscriptionAction(type) {
        this.setFieldValue(FieldsFactory.FIELD_SUBSCRIPTION_ACTION, type);
    }
}
